import { QUESTION_TYPES } from "portfolio/constants";

/**
 * The display text of a task-question answer (PORTFOLIO-CHECKBOX-ANSWER-001). A checkbox
 * question holds the ticked options; they go one per line, so render the result with
 * `tw-whitespace-pre-line`.
 */
export const formatQuestionAnswer = (
  answer: string | string[] | null | undefined,
): string | null => {
  if (Array.isArray(answer)) {
    return answer.length > 0 ? answer.join("\n") : null;
  }

  return answer ?? null;
};

/** The form model of an unanswered question: a checkbox group needs an array to tick into. */
export const emptyQuestionAnswer = (type: string): string[] | null =>
  type === QUESTION_TYPES.CHECKBOX ? [] : null;

/**
 * The string a star-rating widget can show; a list answer never is one, so it narrows to
 * null instead of being handed to `c-star-rating`.
 */
export const starRatingAnswer = (
  answer: string | string[] | null | undefined,
): string | null => (typeof answer === "string" ? answer : null);
